import { useEffect, useState } from "react";
import { fetchInbox } from "@/api/market";
import { errorMessage } from "@/api/auth";
import { useSession } from "@/session/SessionContext";

type InboxItem = {
  id?: string | number;
  title?: string;
  shop?: string;
  status?: string;
  deliver_status?: string;
  created_at?: string;
  codes?: string[];
};

export function InboxPanel() {
  const { token } = useSession();
  const [items, setItems] = useState<InboxItem[]>([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!token) return;
    fetchInbox(token)
      .then((rows) => setItems(rows as InboxItem[]))
      .catch((e) => setErr(errorMessage(e)));
  }, [token]);

  if (!token) {
    return (
      <section className="panel">
        <p className="muted">SESSION</p>
      </section>
    );
  }

  return (
    <section className="panel">
      {err && <p className="net-error">{err}</p>}
      <div className="wallet-grid">
        {!items.length && !err && <p className="muted">۰</p>}
        {items.map((it, i) => (
          <article key={String(it.id ?? i)} className="card">
            <div className="row-between">
              <b>{it.title || it.shop || "inbox"}</b>
              <span className="muted">{it.deliver_status || it.status || "—"}</span>
            </div>
            {(it.codes || []).map((c) => (
              <code key={c} className="addr ltr">
                {c}
              </code>
            ))}
          </article>
        ))}
      </div>
    </section>
  );
}
